import api from './axios';

export const getAudienceFiltersApi = () => api.get('/admin/audience/filters');
export const buildAudienceApi = (data) => api.post('/admin/audience/build', data);
export const getSegmentsApi = (params = {}) => api.get('/admin/audience/segments', { params });
export const saveSegmentApi = (data) => api.post('/admin/audience/segments', data);
export const updateSegmentApi = (id, data) => api.put(`/admin/audience/segments/${id}`, data);
export const deleteSegmentApi = (id) => api.delete(`/admin/audience/segments/${id}`);
export const previewSegmentApi = (id) => api.get(`/admin/audience/segments/${id}/preview`);
export const exportAudienceMatchApi = (data) =>
  api.post('/admin/audience/export-match', data, { responseType: 'blob' });
